document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.shop-by-brand');
  if (!section) return;

  const track = section.querySelector('[data-brand-track]');
  const progressBar = section.querySelector('[data-brand-progress]');

  const prev = section.querySelector('[data-prev]');
  const next = section.querySelector('[data-next]');

  if (!track || !progressBar) return;

  const scrollAmount = 180;

  if (prev) {
    prev.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
  }

  if (next) {
    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  function updateProgress() {
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (maxScroll <= 0) {
      progressBar.style.width = '30%';
      return;
    }

    const visibleRatio = track.clientWidth / track.scrollWidth;
    const minBarWidth = Math.max(30, visibleRatio * 100);
    const traveled = (track.scrollLeft / maxScroll) * (100 - minBarWidth);
    progressBar.style.width = `${minBarWidth}%`;
    progressBar.style.transform = `translateX(${traveled}%)`;
  }

  track.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
  updateProgress();
});
